import { useEffect, useState } from "react";

import { useCountdown, useGenerateQRCodeQuery, useVerifyQRCodeQuery } from "modules/Login/components/QrLogin/hooks";
import { setPermanentSession } from "modules/Login/hooks";

export const useLoginQRCode = (TIMEOUT: number) => {
  const [isVerified, setIsVerified] = useState(false);

  const { secondsLeft, isExpired, start } = useCountdown(TIMEOUT);

  const generateQRCode = useGenerateQRCodeQuery();
  const verifyQRCode = useVerifyQRCodeQuery({ enabled: !isVerified && !isExpired && !generateQRCode.isFetching, token: generateQRCode.data });

  useEffect(() => {
    if (generateQRCode.data) start();
  }, [generateQRCode.data]);

  useEffect(() => {
    if (verifyQRCode.data?.logged_in) {
      setPermanentSession(verifyQRCode.data);
      setIsVerified(true);
    }
  }, [verifyQRCode.data]);

  return { generateQRCode, verifyQRCode, isExpired, isVerified, secondsLeft };
};
